export enum EkranPodsumowaniaActionType {
  KLIKNIETO_KALKULUJ = '[Ekran podsumowania] Kliknieto kalkuluj',
  KLIKNIETO_KALKULUJ_SUCCESS = '[Ekran podsumowania] Wywolano kaluklacje',
  ZAPISZ_STORE = '[Ekran podsumowania] zapisz store',
  POMIN_EKRAN_ROSZCZEN = '[Ekran podsumowania] Pomin ekran pytania o roszczenia',
  POMIN_EKRAN_ROSZCZEN_EKRAN_BRAKU_PREZENTACJI_KWOTY = '[Ekran podsumowania] Pomin ekran pytania o roszczenia i przekieruj na ekran braku prezentacji kwoty',
  POMIN_EKRAN_ROSZCZEN_ROSZCZENIE_Z_UZUPELNIONYM_ROSZCZENIEM = '[Ekran podsumowania] Pomin ekran pytania o roszczenia i przekieruj na ekran akceptacji kwoty',
  KLIKNIETO_WYLICZ_POZNIEJ = '[Ekran podsumowania] Kliknieto wylicz pozniej',
  KLIKNIETO_WYLICZ_POZNIEJ_SUCCESS = '[Ekran podsumowania] Odlozono samoobsluge'
}
